import UserBus from '../buses/userBus'

export default (to, from, next) => {
    if (UserBus.userIs.salesRep()) {
        next()
    } else {
        next(false)
    }
}
